import { createContext, PropsWithChildren, useContext, useState } from 'react';
import { useSearchParams } from 'react-router';

type ClientCommunicationDrawerContextData = {
  isClientCommunicationDrawerOpen: boolean;
  setIsClientCommunicationDrawerOpen: (isOpen: boolean) => void;
};

const ClientCommunicationDrawerContext = createContext<ClientCommunicationDrawerContextData>(
  {} as ClientCommunicationDrawerContextData
);

export const ClientCommunicationDrawerProvider = ({ children }: PropsWithChildren) => {
  const [searchParams] = useSearchParams();
  const [isClientCommunicationDrawerOpen, setIsClientCommunicationDrawerOpen] = useState<boolean>(
    searchParams.get('openClientCommunication') === 'true'
  );

  return (
    <ClientCommunicationDrawerContext.Provider
      value={{ isClientCommunicationDrawerOpen, setIsClientCommunicationDrawerOpen }}
    >
      {children}
    </ClientCommunicationDrawerContext.Provider>
  );
};

export const useClientCommunicationDrawerContext = () => {
  return useContext(ClientCommunicationDrawerContext);
};
